/* global App */
const BaseRouter = require('./base')
const views = require('./views')

module.exports = BaseRouter.extend({
    routings: null,

    initialize () {
        // NOTE: Routes added later may override previously declared routes.
        this.routings = []

        // User
        // Change email
        this.routings.push({
            key: 'accountConfirm',
            path: new RegExp(`${App.urlRegexTo('account/update-email')}.*$`),
            view: views.AccountCounterView,
        })

        this.routings.push({
            key: 'accountConfirm',
            path: new RegExp(`${App.urlRegexTo('user/account/confirm')}.*$`),
            view: views.AccountCounterView,
        })

        this.routings.push({
            key: 'accountUnsubscribe',
            path: new RegExp(`${App.urlRegexTo('user/account/unsubscribe-from-commercials')}.*$`),
            view: views.AccountCounterView,
        })

        this.routings.push({
            key: 'accountEdit',
            path: new RegExp(`${App.urlRegexTo('account/edit')}.*$`),
            view: views.AccountEditView,
        })

        this.routings.push({
            key: 'userPreferences',
            path: new RegExp(`${App.urlRegexTo('user-preferences/auto-deposit')}.*$`),
            view: views.UserPreferencesView,
        })

        this.routings.push({
            key: 'requestPasswordReset',
            path: new RegExp(`${App.urlRegexTo('account/request-password-reset')}.*$`),
            view: views.AccountRequestPasswordResetView,
        })
        this.routings.push({
            key: 'resetPassword',
            path: new RegExp(App.urlRegexTo('user/account/reset-password')),
            view: views.AccountResetPasswordView,
        })

        this.routings.push({
            key: 'kioskResetPassword',
            path: new RegExp(App.urlRegexTo('kiosk/reset-password')),
            view: views.KioskResetPasswordView,
        })

        // Parking
        this.routings.push({
            key: 'parkingSearch',
            path: new RegExp(`${App.urlRegexTo('parking/list')}.*$`),
            view: views.EmptyView,
        })

        // Booking
        this.routings.push({
            key: 'booking',
            path: new RegExp(`${App.urlRegexTo('booking/show')}.*$`),
            view: views.BookingShowView,
        })

        this.routings.push({
            key: 'booking',
            path: new RegExp(`${App.urlRegexTo('booking/new')}.*$`),
            view: views.BookingShowView,
        })

        // Season Ticket Contract
        this.routings.push({
            key: 'seasonTicketContract',
            path: new RegExp(`${App.urlRegexTo('season-ticket-contract/show')}.*$`),
            view: views.SeasonTicketContractShowView,
        })

        this.routings.push({
            key: 'seasonTicketContract',
            path: new RegExp(`${App.urlRegexTo('season-ticket-contract/new')}.*$`),
            view: views.SeasonTicketContractShowView,
        })

        // Season Ticket
        this.routings.push({
            key: 'seasonTicket',
            path: new RegExp(`${App.urlRegexTo('season-ticket/contract')}.*$`),
            view: views.SeasonTicketContractView,
        })

        // Ser ticket
        this.routings.push({
            key: 'serTicketShow',
            path: new RegExp(`${App.urlRegexTo('ser-ticket/show')}.*$`),
            view: views.SerTicketShowView,
        })

        this.routings.push({
            key: 'serTicketShow',
            path: new RegExp(`${App.urlRegexTo('ser-ticket/new')}.*$`),
            view: views.SerTicketShowView,
        })

        this.routings.push({
            key: 'serTicketShow',
            path: new RegExp(`${App.urlRegexTo('ser-ticket/pay')}.*$`),
            view: views.SerTicketPayView,
        })

        this.routings.push({
            key: 'serTicketUnpark',
            path: new RegExp(`${App.urlRegexTo('ser-ticket/unpark')}.*$`),
            view: views.SerTicketUnparkView,
        })

        // Landing operators
        this.routings.push({
            key: 'landingOperators',
            path: new RegExp(`${App.urlRegexTo('site/operators')}$`),
            view: views.LandingOperatorsView,
        })

        // Landing Merchant how it works
        this.routings.push({
            key: 'landingMerchantHowItWorks',
            path: new RegExp(`${App.urlRegexTo('site/landing-merchant-how-it-works')}.*$`),
            view: views.LandingMerchantHowItWorksView,
        })

        // Migration notice
        this.routings.push({
            key: 'migrationNotice',
            path: new RegExp(`${App.urlRegexTo('site/migration-notice')}.*$`),
            view: views.MigrationNoticeView,
        })

        // SerFine notice
        this.routings.push({
            key: 'serFineCancel',
            path: new RegExp(`${App.urlRegexTo('ser-fine/request-cancel')}.*$`),
            view: views.RequestCancelView,
        })

        // Orders
        this.routings.push({
            key: 'orderList',
            path: new RegExp(`${App.urlRegexTo('order/list')}.*$`),
            view: views.OrderListView,
        })

        // OfferedParkingPass
        this.routings.push({
            key: 'passContract',
            path: new RegExp(`${App.urlRegexTo('offered-parking-pass/contract')}.*$`),
            view: views.OfferedParkingPassContractView,
        })

        // BookedParkingPass
        this.routings.push({
            key: 'passNew',
            path: new RegExp(`${App.urlRegexTo('booked-parking-pass/new')}.*$`),
            view: views.BookedParkingPassListNew,
        })

        this.routings.push({ key: 'invoiceList', path: new RegExp(`${App.urlRegexTo('invoice/list')}.*$`), view: views.EmptyView })

        this.generateRoutes()
    }
})
